// import React, { useContext } from "react";
// import { Navbar, Nav, Container } from "react-bootstrap";
// import search from "../../assets/search-logo.svg";
// import { Link } from "react-router-dom";
// import NavDropdown from "react-bootstrap/NavDropdown";
// import Offcanvas from "react-bootstrap/Offcanvas";
// import { useState } from "react";

// function WorksDetailsHeader({ onTagClick }) {
//   const [offcanvasOpen, setOffcanvasOpen] = useState(false);

//   const handleOffcanvasToggle = () => {
//     setOffcanvasOpen(!offcanvasOpen);
//   };
//   const handleOffcanvasClose = () => {
//     setOffcanvasOpen(false);
//   };

//   return (
//     <header className="wide-container  fixed " id="header">
//       <Container className="navigation-wrapper" fluid>
//         <Navbar
//           bg="transparent"
//           variant="dark"
//           expand="lg"
//           className="nav-row first-row "
//         >
//           <Link to="/homepage">
//             <Navbar.Brand href="index.html" className="brand-logo">
//               <img
//                 src={search}
//                 width="150"
//                 height="150"
//                 alt="React Bootstrap logo"
//               />
//             </Navbar.Brand>
//           </Link>
//           <Navbar.Toggle
//             aria-controls="basic-navbar-nav"
//             onClick={handleOffcanvasToggle}
//           />
//           <Navbar.Offcanvas
//             id="offcanvasNavbar"
//             aria-labelledby="offcanvasNavbarLabel"
//             placement="end"
//             className="home-offcanvas-custom"
//             show={offcanvasOpen}
//             onHide={handleOffcanvasClose}
//           >
//             <Offcanvas.Header closeButton>
//               <Offcanvas.Title id="offcanvasNavbarLabel"></Offcanvas.Title>
//             </Offcanvas.Header>
//             <Offcanvas.Body>
//               <Navbar.Collapse>
//                 <Nav
//                   className="list-inline nav-links menu custom-ml "
//                   id="menu"
//                 >
//                   <NavDropdown.Item href="#action3">
//                     <Nav.Link
//                       className={offcanvasOpen ? "black-text" : "white-text"}
//                       href="/Office"
//                     >
//                       Office
//                     </Nav.Link>
//                   </NavDropdown.Item>
//                   <NavDropdown.Item href="#action3">
//                     <Link to="/works" className="text-decoration-none">
//                       <Nav.Link
//                         className={offcanvasOpen ? "black-text" : "white-text"}
//                         href="/Works"
//                       >
//                         Works
//                       </Nav.Link>
//                     </Link>
//                   </NavDropdown.Item>
//                   <NavDropdown.Item href="#action3">
//                     <Nav.Link
//                       className={offcanvasOpen ? "black-text" : "white-text"}
//                       href="/News"
//                     >
//                       News
//                     </Nav.Link>
//                   </NavDropdown.Item>
//                   <NavDropdown.Item href="#action3">
//                     <Nav.Link
//                       className={offcanvasOpen ? "black-text" : "white-text"}
//                       href="/Contact"
//                     >
//                       Contact
//                     </Nav.Link>
//                   </NavDropdown.Item>
//                 </Nav>
//               </Navbar.Collapse>
//             </Offcanvas.Body>
//           </Navbar.Offcanvas>
//         </Navbar>
//       </Container>
//     </header>
//   );
// }

// export default WorksDetailsHeader;
import React, { useState, useEffect } from "react";
import {
  Navbar,
  Nav,
  Container,
  Offcanvas,
  NavDropdown,
} from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import search from "../../assets/logo (2).svg";
// import search from "../../assets/search-logo.svg";

const WorksDetailsHeader = ({ onTagClick }) => {
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Function to toggle offcanvas
  const handleOffcanvasToggle = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };

  // Function to close offcanvas
  const handleOffcanvasClose = () => {
    setOffcanvasOpen(false);
  };

  // Scroll event handler
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <header
        className={`wide-container fixed ${scrolled ? "scrolled" : "default"}`}
        id="header"
      >
        <Container className="navigation-wrapper" fluid>
          <Navbar expand="lg" className="nav-row first-row">
            <Link to="/homepage" className="text-decoration-none">
              <Navbar.Brand className="brand-logo">
                <img
                  src={search}
                  width="178px"
                  height="33px"
                  alt="React Bootstrap logo"
                />
              </Navbar.Brand>
            </Link>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              onClick={handleOffcanvasToggle}
            />
            <Navbar.Offcanvas
              id="offcanvasNavbar"
              aria-labelledby="offcanvasNavbarLabel"
              placement="end"
              className="office-offcanvas-custom"
              show={offcanvasOpen}
              onHide={handleOffcanvasClose}
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id="offcanvasNavbarLabel"></Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Navbar.Collapse id="basic-navbar-nav" className="ms-auto">
                  <Nav className="menu list-inline custom-ml" id="menu">
                    {/* <NavDropdown.Item href="#action3"> */}
                    <Nav.Link
                      as={Link}
                      to="/Office"
                      // href="/Office"
                      className={offcanvasOpen ? "white-text" : "black-text"}
                    >
                      Office
                    </Nav.Link>
                    {/* </NavDropdown.Item> */}
                    {/* <NavDropdown.Item href="#action3"> */}
                    {/* <Link to="/works" className="text-decoration-none"> */}
                    <Nav.Link
                      as={Link}
                      to="/Works"
                      // href="/Works"
                      className={`${
                        offcanvasOpen ? "white-text" : "black-text"
                      } active`}
                    >
                      Works
                    </Nav.Link>
                    {/* </Link> */}
                    {/* </NavDropdown.Item> */}
                    {/* <NavDropdown.Item */}
                    <Nav.Link
                      as={Link}
                      to="/news"
                      activeClassName="active"
                      className="text-decoration-none"
                    >
                      News
                    </Nav.Link>
                    {/* </NavDropdown.Item> */}
                    {/* <NavDropdown.Item href="#action3" className="active"> */}
                    {/* <Link to="/contact" className="text-decoration-none"> */}
                    <Nav.Link
                      // href="/Contact"
                      as={Link}
                      to="/Contact"
                      className={`${
                        offcanvasOpen ? "white-text" : "black-text"
                      } `}
                    >
                      Contact
                    </Nav.Link>
                    {/* </Link> */}
                    {/* </NavDropdown.Item> */}
                  </Nav>
                </Navbar.Collapse>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Navbar>
        </Container>
      </header>

      <style>
        {`
          #header {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            width: 100%;
            z-index: 999999999999999;
            transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
          }

          /* Default style before scroll */
          #header.default {
            background-color: transparent;
          }

          #header.default .nav-link,
          #header.default .navbar-brand,
          #header.default .offcanvas-header,
          #header.default .offcanvas-body {
            color: white !important;
          }

          /* Style after scroll */
          #header.scrolled {
            background-color: white;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

          }

          #header.scrolled .nav-link,
          #header.scrolled .navbar-brand,
          #header.scrolled .offcanvas-header,
          #header.scrolled .offcanvas-body {
            color: black !important;
          }

          .brand-logo img {
            display: block;
            width: 178px;
            height: 33px;
          }

          .nav-link.active {
            color: #007bff !important;
          }
        `}
      </style>
    </>
  );
};

export default WorksDetailsHeader;
